import React, { Fragment } from "react"
import "./body-consulting-room.scss"
import Button from "../../../shared/components/atoms/button/button"
import NavigatorSteps from "../../atoms/navigator-steps/navigator-steps"
import useForm from "react-hook-form"
import { useStaticQuery, graphql } from "gatsby"
import { siteUrl } from "../../../shared/utils/siteUrl"
import ConsultingService from "../../../shared/services/consulting-service"
import RedeemService from "../../../shared/services/redeem-service"
import StandardModal from "../../../shared/components/modals/standard-modal/standard-modal"
import ValidatePoints from "../../molecules/validate-points/validate-points"
import DataPolicy from "../../../shared/components/atoms/data-policy/data-policy"
import * as reCaptchaKey from "../../../shared/constants/reCaptcha"
import ReCAPTCHA from "react-google-recaptcha"
import useDataPolicy from "../../../shared/hooks/useDataPolicy"
import UseChecksPolicy from "../../../shared/hooks/useChecksPolicy"
import DataPolicyService from "../../../shared/services/datapolicy-service"

const BodyConsultingRoom = props => {
  const { etiquetas, slug, tieneRedencion, title } = props.context
  const competitionId = props.context.idActividadConsultorio
  const resultQuery = useStaticQuery(
    graphql`
        query TERMS_QUERY_COUNSULTING {
            allContentfulNolFooter {
                nodes {
                    node_locale
                    politicaPrivacidadDatos
                    terminosYCondiciones
                    redireccionPoliticaPrivacidadDatos
                    redireccionTerminosYCondiciones
                }
            }
        }
    `,
  )
  var homeLink = siteUrl + "/"
  var termsContentful = resultQuery.allContentfulNolFooter.nodes.filter(
    e => e.node_locale === process.env.LOCALE,
  )[0]

  const { checksPolicy } = useDataPolicy()
  const {getPayloadCheck} = UseChecksPolicy()


  const [activeItem, setActiveItem] = React.useState(
    etiquetas ? etiquetas[0].nombreEtiqueta : "",
  )
  const recaptchaRef = React.useRef(null)
  const [step, setStep] = React.useState(1)
  const [tokenID, setTokenID] = React.useState()
  const [disablebtn, setDisablebtn] = React.useState(false)
  const [animationEffect, setanimationEffect] = React.useState("")
  const [notErrors, setnotErrors] = React.useState(true)
  const [counsultingInfo, setCounsultingInfo] = React.useState({
    consulting: "",
    email: "",
    emailConfirm: "",
    cellPhone: "",
    age: "",
  })
  const identificationType = [
    {
      label: "Tarjeta de identidad",
      value: "TI",
    },
    {
      label: "Cédula de ciudadanía",
      value: "CC",
    },
    {
      label: "Cédula de extranjería",
      value: "CE",
    },
    {
      label: "Nit",
      value: "NIT",
    },
  ]

  const {
    register,
    handleSubmit,
    errors,
    triggerValidation,
    setError,
    clearError,
  } = useForm({
    defaultValues: {
      email: "",
      emailConfirm: "",
      cellPhone: "",
      age: "",
    },
  })

  const HandleStep = step => {
    if (step === 2) {
      if (counsultingInfo.consulting !== "") {
        setStep(step)
      }
    } else if (step === 0) {
      window.location.reload()
    } else {
      setStep(step)
    }
  }

  const handleChange = e => {
    triggerValidation({ name: e.target.name })
    if (e.target.value === " " && counsultingInfo.consulting === "") {
      setCounsultingInfo({ ...counsultingInfo, [e.target.name]: "" })
    } else {
      setCounsultingInfo({
        ...counsultingInfo,
        [e.target.name]: e.target.value.replace(/ {2}/g, " "),
      })
    }
  }

  const saveConsulting = () => {
    var payload = {
      consultingType: slug.toUpperCase(),
      consultingTopic: activeItem,
      description: counsultingInfo.consulting,
      email: counsultingInfo.email,
      cellphone:
        process.env.COUNTRY_PHONE_PREFIX +
        parseInt(counsultingInfo.cellPhone).toString(),
      age: counsultingInfo.age,
      tyc: 1.0,
      puytd: 1.0,
      countryId: parseInt(process.env.COUNTRY_CODE),
      documentType: counsultingInfo.identificationType,
      document: counsultingInfo.document,
      captcha: recaptchaRef.current.getValue(),
    }
    ConsultingService.saveConsulting(payload)
      .then(response => {
        if (response.status === 200) {
          var consulting = {
            consulting: "",
            email: "",
            emailConfirm: "",
            cellPhone: "",
            age: "",
            documentType: "",
            document: "",
          }
          setCounsultingInfo(consulting)
          let step = 1
          if (tieneRedencion) step = 0
          // si hay sesion actulizar habeas data
          if (localStorage.getItem("TOKEN_INFO") !== null) {
            const token = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
            const config = {
              headers: {
                Authorization: token,
              },
            }
            DataPolicyService.updatePolicy(getPayloadCheck(), config)
              .then(res => {
                console.log('Habeas data update')
              })
          }
          props.setModalActive(
            <StandardModal
              title="¡Tu consulta ha sido"
              subtitle="ENVIADA EXITOSAMENTE!"
              description={
                "Te notificaremos cuando una de nuestras especialistas haya respondido tu consulta. " +
                (process.env.LOCALE === "es-AR" ? "Recordá" : "Recuerda") +
                " que esta te llegará a tu correo electrónico."
              }
              button_title="Ver otras consultas"
              click={() => {
                props.setModalActive("")
                HandleStep(step)
              }}
            />,
          )
        } else if (response.status === 400 && response.errorCode == "DEM010") {
          setError("email", "string", response.userMessage)
        }
      })
      .catch(err => {
        console.log(err)
        props.setModalActive(
          <StandardModal
            title="¡Uups"
            subtitle="ALGO HA FALLADO!"
            description={"Algo falló al realizar la consulta."}
            button_title="Aceptar"
            click={() => {
              props.setModalActive("")
              setDisablebtn(false)
            }}
          />,
        )
      })
      .finally(() => {
        setDisablebtn(false)
        recaptchaRef.current.execute()
      })
  }

  const redeemPoints = () => {
    let config = {
      headers: {
        Authorization: tokenID,
      },
    }

    let payload = {
      competitionId,
    }
    RedeemService.postPointsRedeem(payload, config)
      .then(res => {
        if (res.status === 200) {
          sessionStorage.setItem("isRedeemPoints", true)
          saveConsulting()
        } else {
          console.error(res, "error")
          props.setModalActive(
            <StandardModal
              title="¡Uups"
              subtitle="ALGO HA FALLADO!"
              description={res.userMessage}
              button_title="Aceptar"
              click={() => {
                props.setModalActive("")
                setDisablebtn(false)
              }}
            />,
          )
        }
      })
      .catch(err => {
        console.error(err)
        props.setModalActive(
          <StandardModal
            title="¡Uups"
            subtitle="ALGO HA FALLADO!"
            description={"Algo falló al realizar la consulta."}
            button_title="Aceptar"
            click={() => {
              props.setModalActive("")
              setDisablebtn(false)
            }}
          />,
        )
      })
  }

  const onSubmit = e => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': 'gaEvent',
      'eventTrigger': 'Consulting',
      'eventCategory': 'Form',
      'eventAction': 'Submit',
      'eventLabel': title, //this have to be dynamically pushed.
      'eventValue': undefined
    })
    if (disablebtn) return
    setDisablebtn(true)
    if (tieneRedencion) {
      redeemPoints()
    } else {
      saveConsulting()
    }
  }

  const calculateAge = () => {
    var today = new Date()
    var birthDate = new Date(
      JSON.parse(localStorage.getItem("USER_INFO")).birthdate.replace(/ /g, "T"),
    )
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  React.useEffect(() => {
    if (tieneRedencion) {
      setStep(0)
    }
    var tokenInfo = localStorage.getItem("TOKEN_INFO")
    const isUserAuth = !!tokenInfo
    if (isUserAuth) {
      const { idToken } = JSON.parse(tokenInfo)
      setTokenID(idToken)
    }
    if (
      slug === "sexologa" &&
      (!localStorage.getItem("TOKEN_INFO") ||
        process.env.LOCALE !== "es-CO" ||
        (localStorage.getItem("USER_INFO") && calculateAge() < 18))
    ) {
      window.location.href = siteUrl + "/entre-nosotras/consultorios"
    }
  }, [])

  React.useEffect(() => {
    recaptchaRef.current.execute()
  }, [])

  React.useEffect(() => {
    setTimeout(() => {
      setanimationEffect("padding-animate")
    }, 100)
    return
  })

  const labelHeaderLoving = "CUÉNTANOS"

  const labelByCountry =
    process.env.LOCALE === "es-PY"
      ? "Seleccioná el tema sobre el que querés resolver tu duda, luego escribí lo que quieres preguntarle a nuestra especialista y esperá tu respuesta. Recordá que nuestro consultorio tiene propósitos informativos y educativos, por eso solo responderemos las preguntas que tengan relación con los temas mencionados, en caso de no aplicar visita a tu especialista."
      : process.env.LOCALE === "es-AR"
        ? "Seleccioná el tema sobre el que tenés una duda, luego escribí lo que querés preguntarle a nuestra especialista y esperá tu respuesta. Recordá que nuestro consultorio tiene propósitos informativos y educativos, por eso solo responderemos las preguntas que tengan relación con los temas mencionados, en caso de no aplicar te recomendamos visitar a tu especialista."
        : "Selecciona el tema sobre el que quieres resolver tu duda, luego escribe lo que quieres preguntarle a nuestra especialista y espera tu respuesta. Recuerda que nuestro consultorio tiene propósitos informativos y educativos, por eso solo responderemos las preguntas que tengan relación con los temas mencionados, en caso de no aplicar visita a tu especialista."

  const labelLoving = <> Durante el mes de mayo, mes en contra del bullying, tendremos 2 psicólogas especialistas, Natalia Cárdenas y Nadia Moratto, que te acompañarán y estarán para ti respondiéndote todas las dudas que tengas. ¡Ellas te podrán orientar ante cualquier situación! Recuerda que las preguntas que hagas son privadas y gratuitas, y se responderán en un plazo de 48 horas. <br /> <br /> ¡Tendrás desde el 2 de mayo hasta el 1 de junio! </>
  return (
    <form
      className="f-body-consulting-room"
      autoComplete="new-password"
      onSubmit={notErrors ? handleSubmit(onSubmit) : e => e.preventDefault()}
    >
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={reCaptchaKey.key}
      />
      {step === 0 && tieneRedencion && (
        <ValidatePoints
          setStep={setStep}
          costRedeem={props.context.valorActividadConsultorio}
          competitionId={props.context.idActividadConsultorio}
        ></ValidatePoints>
      )}

      {step === 1 && (
        <div>
          {slug === "loving" ? (
            <h3>
              <span>¿Has vivido algún momento de</span> bullying?
            </h3>
          ) : (
            <h3>
              <span>
                ¿Qué {process.env.LOCALE === "es-PY" ? "querés" : "quieres"}
              </span>{" "}
              consultar?
            </h3>
          )}
          {etiquetas && slug === "loving" ? (
            <h4>{labelHeaderLoving}</h4>
          ) : (
            <h4>¿SOBRE QUÉ TEMA ES TU CONSULTA?</h4>
          )}
          {etiquetas && (
            <p className="f-body-consulting-room-copyppl">
              {slug === "loving" ? labelLoving : labelByCountry}
            </p>
          )}
          {etiquetas && (
            <div className={"f-body-consulting-room-tags " + animationEffect}>
              {etiquetas.map((tag, index) => {
                return (
                  <div
                    key={index}
                    className={
                      activeItem === tag.nombreEtiqueta
                        ? "f-body-consulting-room-tag active"
                        : "f-body-consulting-room-tag"
                    }
                    onClick={() => {
                      setActiveItem(tag.nombreEtiqueta)
                    }}
                  >
                    <p>{tag.nombreEtiqueta}</p>
                    <span className="icon-check-2"></span>
                  </div>
                )
              })}
            </div>
          )}
          <h4>ESCRIBE TU CONSULTA</h4>
          <textarea
            name="consulting"
            value={counsultingInfo.consulting}
            onChange={event => {
              if (
                !/^[ a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/.test(
                  event.target.value
                ) &&
                event.target.value !== ""
              ) {
                return false
              } else {
                handleChange(event)
              }
            }}
            maxLength="1000"
          />
          <NavigatorSteps step={1} HandleStep={HandleStep} />
          <div className="f-btn-next">
            <div
              onClick={() => HandleStep(2)}
              className={
                counsultingInfo.consulting === "" ? "disable f-btn-next" : ""
              }
            >
              <Button className="primary-blue alter short" title="Siguiente" />
            </div>
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="f-body-consulting-room-form">
          <h3>
            <span>
              ¿Qué {process.env.LOCALE === "es-PY" ? "querés" : "quieres"}
            </span>{" "}
            consultar?
          </h3>
          <span className="f-body-consulting-room-form-error-generic">
            {errors.terms || errors.politics
              ? ""
              : Object.keys(errors).length > 0 &&
              "*Revisa que todos los campos estén correctamente"}
          </span>
          <div className="f-body-consulting-room-form-items">
            <div>
              <h4>INGRESA TU CORREO</h4>
              <input
                className={errors.email ? "f-error-value" : ""}
                maxLength="60"
                id={"counsulting-email"}
                autoComplete="new-password"
                onBlur={handleChange}
                type="email"
                name="email"
                ref={register({
                  required: true,
                  pattern: /^(([^<>()[\]\\.,;:=\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                })}
              />
              {
                errors.email && (
                  <span className="f-body-consulting-room-form-error-generic">
                    {errors.email.message}
                  </span>
                )
              }
            </div>
            <div>
              <h4>CONFIRMA TU CORREO</h4>
              <input
                onChange={e => {
                  if (e.target.value !== counsultingInfo.email) {
                    setnotErrors(false)
                    setError("emailConfirm", "notEqual")
                  } else {
                    setnotErrors(true)
                    clearError("emailConfirm", "notEqual")
                  }
                }}
                className={errors.emailConfirm ? "f-error-value" : ""}
                maxLength="60"
                id={"counsulting-emailConfirm"}
                autoComplete="new-password"
                onBlur={handleChange}
                type="email"
                name="emailConfirm"
                ref={register({
                  required: true,
                  pattern: /^(([^<>()[\]\\.,;:=\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                })}
              />
              {!notErrors && (
                <span className="f-body-consulting-room-form-error-generic">
                  El email no coincide
                </span>
              )}
            </div>
          </div>
          <div className="f-body-consulting-room-form-items">
            <div>
              <h4>TIPO DE IDENTIFICACIÓN</h4>
              <div className="f-select-container">
                <select
                  className={errors.identificationType ? " f-error-value" : ""}
                  name="identificationType"
                  autoComplete="off"
                  id={"outlined-month"}
                  onBlur={handleChange}
                  ref={register({ required: true })}
                >
                  <option value="" hidden>Selecciona un tipo</option>
                  {identificationType.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <span className="icon-down icon-select" />
              </div>
            </div>
            <div>
              <h4>INGRESA TU DOCUMENTO</h4>
              <input
                className={errors.document ? "f-error-value" : ""}
                maxLength="60"
                id={"counsulting-document"}
                autoComplete="new-password"
                onBlur={handleChange}
                type="number"
                name="document"
                ref={register({
                  required: true,
                  minLength: 5,
                  maxLength: 15,
                })}
              />
            </div>
          </div>
          <div className="f-body-consulting-room-form-items">
            <div>
              <h4>
                INGRESA TU CELULAR{" "}
                <span className="icon-alert">
                  <p>
                    Nos comunicaremos contigo cuando sea necesario.
                    <span className="tooltip"></span>
                  </p>
                </span>
              </h4>
              <input
                className={errors.cellPhone ? "f-error-value" : ""}
                maxLength="60"
                id={"counsulting-cellphone"}
                onBlur={handleChange}
                autoComplete="new-password"
                type="number"
                name="cellPhone"
                pattern="\d*"
                ref={register({
                  required: true,
                  maxLength: parseInt(process.env.MAX_DIGITS),
                  minLength: parseInt(process.env.MIN_DIGITS),
                  min: 0,
                })}
              />
            </div>
            <div>
              <h4>TU EDAD</h4>
              <input
                className={errors.age ? "f-error-value" : ""}
                // maxLength="60"
                autoComplete="new-password"
                id={"counsulting-age"}
                onBlur={handleChange}
                type="number"
                name="age"
                pattern="\d*"
                // maxLength="2"
                ref={register({ required: true, min: 1, max: 90 })}
              />
            </div>
          </div>
          <NavigatorSteps step={2} HandleStep={HandleStep} />
          <div className="f-body-consulting-room-links ">
            <div className="f-body-consulting-room-links-group">

              {checksPolicy.map(term => {
                if (term.idPrincipal !== "pbAccepted") {
                  return (
                    <div key={term.idPrincipal}>
                      <input
                        type="checkbox"
                        name={term.idPrincipal}
                        value={term.idPrincipal}
                        ref={register({ required: true })}
                      />
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                          homeLink + term.redireccion
                        }
                      >
                        {term.tituloPrincipal}
                      </a>
                      <span className="f-checkmark"></span>
                    </div>
                  )
                }

              })}


              <span className="f-body-consulting-room-form-error-generic">
                {(errors.tycAccepted || errors.uytdAccepted) && "*Debes aceptar todos términos"}
              </span>

              <DataPolicy />
            </div>


            <Button
              type={"submit"}
              className={
                disablebtn
                  ? "primary-blue alter short dissable"
                  : "primary-blue alter short"
              }
              title="Enviar consulta"
            />
          </div>
        </div>
      )}
    </form>
  )
}

export default BodyConsultingRoom
